  // export const BASE_URL = "http://localhost:8082";
export const BASE_URL = "https://back.devaccounts.com";

 